var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 83,
    viewBox: "0 0 161 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.911 41.6457C142.309 26.5331 119.528 16.6342 95.183 13.0857C70.8382 9.53729 45.9171 12.4832 23.2814 21.5851L15.0511 24.8977C11.6676 30.1045 9.89051 36.0857 9.9167 42.1789C9.94289 48.2721 11.7713 54.2396 15.1995 59.4209L23.4495 62.6687C46.1571 71.6102 71.1 74.3806 95.4147 70.662C119.729 66.9434 142.43 56.8864 160.911 41.6457Z",
    fill: "#F9FAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2499 20.8356C24.5872 21.0855 23.9343 21.326 23.2715 21.5851L15.0412 24.8885C11.6579 30.0971 9.88103 36.0796 9.90722 42.1743C9.93341 48.2689 11.7616 54.2379 15.1896 59.4209L23.4397 62.6687C24.0925 62.9278 24.7553 63.1591 25.4181 63.409C21.3616 56.9642 19.2084 49.627 19.1788 42.1482C19.1493 34.6694 21.2444 27.3175 25.2499 20.8449V20.8356Z",
    fill: "#D7D9DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2715 21.5851C23.9343 21.326 24.5872 21.0855 25.2499 20.8356V20.8449C21.2444 27.3175 19.1493 34.6694 19.1788 42.1482L9.90722 42.1743C9.88103 36.0796 11.6579 30.0971 15.0412 24.8885L23.2715 21.5851Z",
    fill: "#5A9CD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.159 41.6458H160.901C153.671 35.7734 145.772 30.6628 137.348 26.406C134.994 31.1691 133.769 36.3521 133.757 41.5995L133.767 41.7013L160.159 41.6458Z",
    fill: "#5A9CD4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.911 41.6457L160.565 41.3774L9.92708 41.9141C9.92708 42.0066 9.92708 42.0899 9.92708 42.1824C9.9625 48.279 11.79 54.2491 15.2095 59.4393L23.4595 62.6872C46.1676 71.6243 71.1097 74.3908 95.4225 70.6689C119.735 66.947 142.433 56.8877 160.911 41.6457Z",
    fill: "#DCDDE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M161 41.5904L160.664 41.322C138.889 53.2163 114.802 60.9413 89.8061 64.0475C64.8841 67.1281 39.5565 65.5556 15.2885 59.421L23.5385 62.6688C46.2515 71.603 71.1976 74.3644 95.5126 70.6359C119.827 66.9074 142.525 56.8403 161 41.5904Z",
    fill: "#CACBCE"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9626 42.4046C69.9528 40.0676 70.6842 37.7804 72.0641 35.8322C73.444 33.884 75.4105 32.3623 77.715 31.4595C80.0195 30.5568 82.5584 30.3135 85.0107 30.7604C87.463 31.2074 89.7186 32.3245 91.4921 33.9705C93.2657 35.6166 94.4776 37.7176 94.9746 40.0079C95.4716 42.2982 95.2314 44.6749 94.2843 46.8375C93.3373 49.0001 91.7259 50.8514 89.654 52.1574C87.5821 53.4634 85.1428 54.1654 82.6444 54.1745C79.2956 54.1819 76.0804 52.9472 73.7032 50.741C71.3261 48.5347 69.9809 45.537 69.9626 42.4046Z",
    fill: "#281C4B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7233 42.3215C93.7311 44.3803 93.086 46.395 91.8697 48.1109C90.6534 49.8269 88.9204 51.1669 86.8899 51.9615C84.8594 52.7561 82.6226 52.9697 80.4624 52.5752C78.3021 52.1807 76.3154 51.1959 74.7535 49.7453C73.1916 48.2947 72.1247 46.4434 71.6876 44.4255C71.2505 42.4077 71.463 40.3139 72.298 38.409C73.1331 36.5041 74.5533 34.8736 76.379 33.7237C78.2047 32.5738 80.354 31.9561 82.555 31.9488C84.0165 31.9439 85.4646 32.2083 86.8168 32.727C88.169 33.2456 89.3987 34.0083 90.4358 34.9715C91.4729 35.9347 92.297 37.0795 92.861 38.3406C93.4251 39.6018 93.7181 40.9544 93.7233 42.3215ZM96.6909 42.3215C96.683 39.7043 95.845 37.1482 94.283 34.9769C92.721 32.8056 90.5053 31.1167 87.9164 30.124C85.3276 29.1314 82.482 28.8798 79.7402 29.4009C76.9983 29.9221 74.4834 31.1926 72.514 33.0516C70.5447 34.9106 69.2093 37.2745 68.6772 39.8439C68.1451 42.4133 68.44 45.0725 69.5247 47.485C70.6095 49.8975 72.4352 51.9546 74.7706 53.3958C77.106 54.837 79.8462 55.5976 82.6441 55.5811C86.3915 55.5639 89.9788 54.1575 92.6194 51.6702C95.26 49.1828 96.7384 45.8176 96.7305 42.3122L96.6909 42.3215Z",
    fill: "#1285A2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5057 34.817C84.092 34.7988 85.6484 35.2213 86.9776 36.0312C88.3069 36.8412 89.3493 38.0019 89.9726 39.3665C90.5959 40.7311 90.7722 42.238 90.4791 43.6963C90.1859 45.1547 89.4366 46.4988 88.326 47.5585C87.2154 48.6181 85.7935 49.3455 84.2406 49.6485C82.6876 49.9515 81.0734 49.8165 79.6025 49.2606C78.1317 48.7046 76.8703 47.7528 75.9783 46.5257C75.0863 45.2986 74.6038 43.8514 74.592 42.3675C74.5761 40.3861 75.3998 38.4794 76.8828 37.0644C78.3658 35.6495 80.3875 34.8414 82.5057 34.817Z",
    fill: "url(#paint0_linear_0_1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.289 42.9319C103.283 41.6285 103.691 40.3528 104.46 39.2661C105.23 38.1794 106.327 37.3307 107.612 36.8273C108.897 36.3238 110.313 36.1883 111.681 36.4379C113.049 36.6874 114.306 37.3109 115.295 38.2293C116.284 39.1477 116.959 40.3198 117.236 41.5973C117.512 42.8748 117.377 44.2003 116.848 45.4061C116.319 46.6118 115.419 47.6437 114.263 48.3711C113.107 49.0984 111.746 49.4886 110.352 49.4923C108.487 49.4948 106.696 48.8059 105.372 47.5763C104.049 46.3468 103.3 44.6768 103.289 42.9319Z",
    fill: "#281C4B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.525 42.8859C116.523 44.0321 116.158 45.1522 115.476 46.1046C114.794 47.0571 113.826 47.7993 112.694 48.2375C111.561 48.6758 110.316 48.7904 109.114 48.567C107.912 48.3436 106.807 47.7921 105.94 46.9822C105.073 46.1724 104.482 45.1403 104.241 44.0164C104 42.8924 104.121 41.727 104.587 40.6671C105.054 39.6072 105.846 38.7004 106.863 38.061C107.88 37.4217 109.077 37.0786 110.303 37.0749C111.117 37.0713 111.924 37.2178 112.677 37.5061C113.43 37.7944 114.116 38.2189 114.694 38.7551C115.272 39.2914 115.731 39.929 116.045 40.6315C116.359 41.3339 116.522 42.0874 116.525 42.8489M118.197 42.8489C118.197 41.3817 117.73 39.9476 116.857 38.7287C115.984 37.5098 114.743 36.5611 113.293 36.0031C111.842 35.4451 110.247 35.3029 108.71 35.5945C107.172 35.8862 105.763 36.5986 104.659 37.6413C103.555 38.6839 102.808 40.0098 102.512 41.4506C102.215 42.8914 102.383 44.3821 102.995 45.7333C103.606 47.0846 104.632 48.2355 105.944 49.0399C107.256 49.8443 108.794 50.266 110.362 50.2513C112.447 50.2318 114.44 49.4433 115.907 48.0572C117.374 46.6711 118.197 44.7994 118.197 42.8489Z",
    fill: "#1285A2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.283 38.7126C111.164 38.7127 112.026 38.9567 112.759 39.4141C113.492 39.8714 114.063 40.5215 114.402 41.2824C114.74 42.0434 114.83 42.881 114.661 43.6898C114.491 44.4985 114.069 45.2421 113.448 45.8268C112.827 46.4115 112.035 46.8112 111.171 46.9753C110.308 47.1394 109.412 47.0608 108.596 46.7492C107.78 46.4375 107.082 45.907 106.588 45.2244C106.094 44.5418 105.828 43.7377 105.822 42.9135C105.818 42.3632 105.93 41.8175 106.153 41.308C106.375 40.7985 106.703 40.3352 107.118 39.9447C107.532 39.5543 108.026 39.2444 108.569 39.0329C109.112 38.8215 109.695 38.7126 110.283 38.7126Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1511 41.7013C47.1276 40.3946 47.5201 39.1108 48.2786 38.0133C49.0372 36.9158 50.1277 36.0541 51.4112 35.5379C52.6948 35.0217 54.1135 34.8742 55.4869 35.1142C56.8603 35.3542 58.1264 35.9709 59.1241 36.8859C60.1218 37.8008 60.806 38.9726 61.0898 40.2523C61.3735 41.532 61.244 42.8617 60.7176 44.0723C60.1912 45.283 59.2918 46.3198 58.1337 47.051C56.9757 47.7821 55.6113 48.1746 54.2141 48.1785C52.3639 48.1812 50.5866 47.5037 49.2654 46.2921C47.9442 45.0805 47.1848 43.4317 47.1511 41.7013Z",
    fill: "#281C4B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3869 41.6088C60.3928 42.7566 60.0345 43.8803 59.3575 44.8376C58.6804 45.7949 57.7149 46.5429 56.5833 46.9868C55.4516 47.4307 54.2046 47.5506 53.0001 47.3314C51.7955 47.1122 50.6876 46.5637 49.8164 45.7553C48.9452 44.9469 48.35 43.9149 48.106 42.79C47.8621 41.665 47.9804 40.4977 48.4459 39.4356C48.9114 38.3736 49.7033 37.4646 50.7213 36.8236C51.7393 36.1827 52.9376 35.8386 54.1648 35.8349C54.9788 35.8312 55.7856 35.9778 56.5391 36.2661C57.2925 36.5544 57.9778 36.9788 58.5557 37.5151C59.1336 38.0514 59.5928 38.689 59.907 39.3914C60.2213 40.0938 60.3843 40.8474 60.3869 41.6088ZM62.0587 41.6088C62.0586 40.1416 61.5924 38.7075 60.7193 37.4886C59.8462 36.2698 58.6055 35.3211 57.1549 34.763C55.7042 34.205 54.109 34.0628 52.5717 34.3545C51.0345 34.6462 49.6246 35.3586 48.5211 36.4012C47.4176 37.4439 46.6701 38.7698 46.3738 40.2106C46.0774 41.6513 46.2455 43.142 46.8566 44.4933C47.4677 45.8445 48.4944 46.9954 49.8061 47.7999C51.1179 48.6043 52.6557 49.0259 54.2241 49.0113C56.3092 48.9917 58.3018 48.2032 59.7689 46.8171C61.2359 45.431 62.0588 43.5593 62.0587 41.6088Z",
    fill: "#1285A2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1448 37.4356C55.0272 37.4302 55.8914 37.6696 56.6283 38.1235C57.3652 38.5775 57.9416 39.2257 58.2847 39.9861C58.6278 40.7465 58.7221 41.585 58.5557 42.3956C58.3893 43.2061 57.9697 43.9523 57.35 44.5398C56.7302 45.1273 55.9381 45.5297 55.0739 45.6961C54.2096 45.8625 53.312 45.7855 52.4946 45.4747C51.6772 45.1639 50.9766 44.6334 50.4815 43.9502C49.9864 43.267 49.719 42.4619 49.7131 41.6365C49.7092 41.0885 49.8208 40.5451 50.0414 40.0374C50.262 39.5297 50.5873 39.0676 50.9988 38.6775C51.4103 38.2874 51.9 37.977 52.4398 37.7639C52.9796 37.5508 53.5589 37.4393 54.1448 37.4356Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1582 19.7068C33.8338 17.8393 39.6165 16.27 45.4794 15.0063C52.2611 13.5475 59.1377 12.5059 66.065 11.888L54.0955 5.9105C44.5172 1.12886 33.4051 -0.226335 22.8363 2.09824L1.7066 6.72477L28.1582 19.7068Z",
    fill: "#F9FAFD"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5629 19.0684C40.0125 15.6232 50.8715 13.3798 61.9003 12.3877L51.6718 7.28003C43.487 3.19634 33.992 2.04174 24.963 4.03221L6.89995 8.01102L29.5629 19.0684Z",
    fill: "#F9FAFD"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0207 63.6959C32.6433 65.6518 38.3801 67.3077 44.2034 68.6556C50.957 70.2242 57.814 71.3741 64.7296 72.0977L52.6513 77.8901C42.9926 82.5282 31.8563 83.7094 21.3327 81.212L0.292068 76.2246L27.0207 63.6959Z",
    fill: "#AAADB3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1671 64.6953C34.1824 66.4363 39.2981 67.913 44.4901 69.1183C50.504 70.5315 56.6107 71.5732 62.7708 72.2366L52.0081 77.3442C43.4019 81.4764 33.4794 82.5293 24.1023 80.3052L5.30725 75.8638L29.1671 64.6953Z",
    fill: "#DCDDE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 98.6856,
    y1: 42.1925,
    x2: 73.2041,
    y2: 42.3779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 119.336,
    y1: 42.8106,
    x2: 105.151,
    y2: 42.9138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 63.1967,
    y1: 41.5301,
    x2: 49.0019,
    y2: 41.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.25dd557ffb3d77adb5a89a21d95197d8.svg";
export { ForwardRef as ReactComponent };